// @mui
import { Container, Stack, Grid } from '@mui/material';
// hooks
import useResponsive from 'src/hooks/useResponsive';
// routes
import { PATH_AUTH } from 'src/routes/paths';
// components
import Page from 'src/components/Page';
import AuthWelcomeBanner from './AuthWelcomeBanner';
// sections
import { RegisterForm } from 'src/sections/auth/register';
// styles
import { SectionStyle, ContentStyle } from './styles';
import useEmbedded from "../../hooks/useEmbedded";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../config";

export default function Register() {
  const mdUp = useResponsive('up', 'md');
  const { isEmbedded, postMessageToParent } = useEmbedded();

  const [localStorageAccessible, setLocalStorageAccessible] = useState(false);

  useEffect(() => {
    if(isEmbedded) {
      let localStorageTest;

      try {
        window.localStorage.setItem('embedded_local_storage_test', 'test');
        localStorageTest = window.localStorage.getItem('embedded_local_storage_test');
      } catch (e) {
        setLocalStorageAccessible(false);
        console.log('Local storage is not accessible')
      }

      if(localStorageTest === 'test') {
        setLocalStorageAccessible(true);
      }
    }
  }, [isEmbedded])

  const handleSignInEmbeddedStorageInaccessibleClick = () => {
    postMessageToParent({
      type: 'PORTAL_SIGNED_UP',
      payload: `${BASE_URL}${PATH_AUTH.login}`
    });
  }
  
  return (
    <Page title="">
      <Container maxWidth={false}>

        <Grid container alignItems={'center'}>
          {mdUp && !isEmbedded && (
            <SectionStyle item xs={12} md={6}>
              <AuthWelcomeBanner />
            </SectionStyle>
          )}

          <Grid item xs={12} md={6}>
            <ContentStyle isEmbedded={isEmbedded}>
              <Stack spacing={{ xs: 4, sm: 6 }}>

                <RegisterForm
                  localStorageAccessible={localStorageAccessible}
                  handleSignInEmbeddedStorageInaccessibleClick={handleSignInEmbeddedStorageInaccessibleClick}
                />

              </Stack>
            </ContentStyle>
          </Grid>
        </Grid>

      </Container>
    </Page>
  );
}
